import React from 'react';
import { Helmet } from 'react-helmet';
import { domainName, hostTitle } from '../../../config/ui';

export default class Confirmation extends React.Component {
  render() {

    return (
      <div id="extr-page">
        <Helmet title={`You're verified! – ${hostTitle()}`} />
        <header id="header" className="animated fadeInDown">
          <div id="logo-group">
            <span id="logo">
              {' '}
              <img src={`assets/img/${domainName()}logo.png`} alt="SmartAdmin" />{' '}
            </span>
          </div>
          <span id="extr-page-header-space">
            <span className="hidden-mobile hiddex-xs">Already activated?</span>
            &nbsp;
            <a href="#login" className="btn btn-danger">
              Try Sign In
            </a>{' '}
          </span>
        </header>
        <div id="main" role="main" className="animated fadeInDown">
          <div id="content" className="container">
            <div className="row">
              <div className="col-sm-12">
                <div className="confirmation">
                  <div><i className="fa fa-check-circle-o"></i></div>
                  <div className="header">Congratulations! You're verified!</div>
                  <div>The administrator has been notified of your request. Once your account is approved, you will receive a confirmation email with further instructions. </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/auth/containers/Confirmation.js